const animationStyle = `
@keyframes ai-loading-icon-vector-transform {
  0% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(3.996px) translateY(3.995px) translate(20.005px, 20.005px) rotate(-0.07rad) scaleX(0.62) scaleY(0.62) translate(-20.005px, -20.005px);
  }
  23.32% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(3.996px) translateY(3.995px) translate(20.005px, 20.005px) rotate(0.052rad) scaleX(1.08) scaleY(1.08) translate(-20.005px, -20.005px);
  }
  31.09% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(3.996px) translateY(3.995px) translate(20.005px, 20.005px) rotate(0rad) scaleX(0.96) scaleY(0.96) translate(-20.005px, -20.005px);
  }
  51.81% {
    transform: translateX(3.996px) translateY(3.995px) translate(20.005px, 20.005px) rotate(-0.07rad) scaleX(0.62) scaleY(0.62) translate(-20.005px, -20.005px);
  }
  100% {
    transform: translateX(3.996px) translateY(3.995px) translate(20.005px, 20.005px) rotate(-0.07rad) scaleX(0.62) scaleY(0.62) translate(-20.005px, -20.005px);
  }
}
@keyframes ai-loading-icon-vector-opacity {
  0% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.42;
  }
  23.32% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
  }
  31.09% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.9;
  }
  51.81% {
    animation-timing-function: linear;
    opacity: 0.42;
  }
  100% {
    opacity: 0.42;
  }
}
.ai-loading-icon #ai-loading-icon-vector {
  transform-origin: 0 0;
  animation:
    ai-loading-icon-vector-transform 1.93s linear infinite,
    ai-loading-icon-vector-opacity 1.93s linear infinite;
}
@keyframes ai-loading-icon-frame-transform {
  0% {
    transform: translateX(33.999px) translateY(2px) translate(6px, 6px) rotate(0rad) scaleX(0.42) scaleY(0.42) translate(-6px, -6px);
  }
  14.91% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(33.999px) translateY(2px) translate(6px, 6px) rotate(0rad) scaleX(0.42) scaleY(0.42) translate(-6px, -6px);
  }
  51.81% {
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    transform: translateX(33.999px) translateY(2px) translate(6px, 6px) rotate(3.142rad) scaleX(1.15) scaleY(1.15) translate(-6px, -6px);
  }
  85.39% {
    transform: translateX(33.999px) translateY(2px) translate(6px, 6px) rotate(0rad) scaleX(0.42) scaleY(0.42) translate(-6px, -6px);
  }
  100% {
    transform: translateX(33.999px) translateY(2px) translate(6px, 6px) rotate(0rad) scaleX(0.42) scaleY(0.42) translate(-6px, -6px);
  }
}
@keyframes ai-loading-icon-frame-opacity {
  0% {
    animation-timing-function: linear;
    opacity: 0.25;
  }
  14.91% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.25;
  }
  51.81% {
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    opacity: 1;
  }
  85.39% {
    animation-timing-function: linear;
    opacity: 0.25;
  }
  100% {
    opacity: 0.25;
  }
}
.ai-loading-icon #ai-loading-icon-frame {
  transform-origin: 0 0;
  animation:
    ai-loading-icon-frame-transform 1.93s linear infinite,
    ai-loading-icon-frame-opacity 1.93s linear infinite;
}
@keyframes ai-loading-icon-circle-transform {
  0% {
    animation-timing-function: linear;
    transform: translateX(3.999px) translateY(36px) translateX(-0.3px) translateY(0.25px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px);
  }
  24.85% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(3.999px) translateY(36px) translateX(-0.299px) translateY(0.3px) translate(4px, 4px) rotate(0rad) scaleX(0.35) scaleY(0.35) translate(-4px, -4px);
  }
  62.18% {
    animation-timing-function: linear;
    transform: translateX(3.999px) translateY(36px) translateX(0.2px) translateY(-0.2px) translate(4px, 4px) rotate(3.142rad) scaleX(1.12) scaleY(1.12) translate(-4px, -4px);
  }
  88.08% {
    animation-timing-function: linear;
    transform: translateX(3.999px) translateY(36px) translateX(-0.247px) translateY(0.203px) translate(4px, 4px) rotate(0.332rad) scaleX(0.431) scaleY(0.431) translate(-4px, -4px);
  }
  100% {
    transform: translateX(3.999px) translateY(36px) translateX(-0.298px) translateY(0.248px) translate(4px, 4px) rotate(0.013rad) scaleX(0.353) scaleY(0.353) translate(-4px, -4px);
  }
}
@keyframes ai-loading-icon-circle-opacity {
  0% {
    animation-timing-function: linear;
    opacity: 0.2;
  }
  24.85% {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.2;
  }
  62.18% {
    animation-timing-function: linear;
    opacity: 1;
  }
  88.08% {
    animation-timing-function: linear;
    opacity: 0.284;
  }
  100% {
    opacity: 0.203;
  }
}
.ai-loading-icon #ai-loading-icon-circle {
  transform-origin: 0 0;
  animation:
    ai-loading-icon-circle-transform 1.93s linear infinite,
    ai-loading-icon-circle-opacity 1.93s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .ai-loading-icon * {
    animation: none !important;
  }
}
`

interface Props {
  size?: 16 | 24 | 48
}

const AiLoadingIcon = ({ size = 48 }: Props) => {
  return (
    <svg
      className='ai-loading-icon shrink-0'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <style>{animationStyle}</style>
      <g clipPath='url(#ai-loading-icon-clip)'>
        <path
          id='ai-loading-icon-vector'
          transform='translate(3.99609 3.99519)'
          d='M18.0388 1.63278C18.1245 1.17399 18.3679 0.7596 18.727 0.4614C19.086 0.16323 19.5381 0 20.0048 0C20.4715 0 20.9236 0.16323 21.2826 0.4614C21.6416 0.7596 21.8851 1.17399 21.9708 1.63278L24.0728 12.7488C24.2221 13.5391 24.6061 14.266 25.1749 14.8347C25.7436 15.4034 26.4704 15.7875 27.2609 15.9368L38.3768 18.0388C38.8355 18.1245 39.2498 18.3679 39.548 18.727C39.8462 19.086 40.0097 19.538 40.0097 20.0048C40.0097 20.4715 39.8462 20.9235 39.548 21.2826C39.2498 21.6416 38.8355 21.8851 38.3768 21.9708L27.2609 24.0728C26.4704 24.2221 25.7436 24.6061 25.1749 25.1748C24.6061 25.7435 24.2221 26.4704 24.0728 27.2609L21.9708 38.3768C21.8851 38.8355 21.6416 39.2498 21.2826 39.548C20.9236 39.8462 20.4715 40.0097 20.0048 40.0097C19.5381 40.0097 19.086 39.8462 18.727 39.548C18.3679 39.2498 18.1245 38.8355 18.0388 38.3768L15.9368 27.2609C15.7875 26.4704 15.4034 25.7435 14.8347 25.1748C14.266 24.6061 13.5391 24.2221 12.7488 24.0728L1.63278 21.9708C1.17399 21.8851 0.75963 21.6416 0.46143 21.2826C0.16323 20.9235 0 20.4715 0 20.0048C0 19.538 0.16323 19.086 0.46143 18.727C0.75963 18.3679 1.17399 18.1245 1.63278 18.0388L12.7488 15.9368C13.5391 15.7875 14.266 15.4034 14.8347 14.8347C15.4034 14.266 15.7875 13.5391 15.9368 12.7488L18.0388 1.63278Z'
          fill='#8051FF'
        />
        <g id='ai-loading-icon-frame' transform='translate(33.999 2.00006)'>
          <path
            transform='translate(4.002)'
            d='M0 10V1.99999C0 0.895431 0.895501 0 2.0001 0C3.1044 0 3.9999 0.895431 3.9999 1.99999V10C3.9999 11.1046 3.1044 12 2.0001 12C0.895501 12 0 11.1046 0 10Z'
            fill='#8051FF'
          />
          <path
            transform='translate(0 3.99994)'
            d='M9.9999 0C11.1045 0 12 0.89544 12 2.00001C12 3.10458 11.1045 3.99999 9.9999 3.99999H2.0001C0.895498 3.99999 0 3.10458 0 2.00001C0 0.89544 0.895498 0 2.0001 0H9.9999Z'
            fill='#8051FF'
          />
        </g>
        <path
          id='ai-loading-icon-circle'
          transform='translate(3.99903 36)'
          d='M3.99999 8.0001C6.20913 8.0001 7.99998 6.2091 7.99998 3.9999C7.99998 1.791 6.20913 0 3.99999 0C1.79085 0 0 1.791 0 3.9999C0 6.2091 1.79085 8.0001 3.99999 8.0001Z'
          fill='#8051FF'
        />
      </g>
      <defs>
        <clipPath id='ai-loading-icon-clip'>
          <rect width='48' height='48' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AiLoadingIcon
